import { Component, Input } from '@angular/core';
import { KycService } from '../../../../core/kyc.service';

@Component({
  selector: "app-main-footer",
  templateUrl: "./main-layout-footer.template.html"
})
export class MainLayoutFooterComponent {
  @Input() buttonTextColor = '#4d4d4d';
  @Input() backgroundColor = '#000000';
  @Input() footerItems: Object[] = [
    {
      value: "Privacy Policy",
      className: "text-left",
      link: "http://www.my-insurer.net/privacy-policy.html"
    },
    {
      value: "Copyright @ My-Insurer Pte Ltd - Singapore",
      className: "text-center"
    },
    {
      value: "Terms & Conditions",
      className: "text-right",
      link: "http://www.my-insurer.net/term--conditions-users.html"
    }
  ];
}



// WEBPACK FOOTER //
// ./src/app/shared/common/layout/main-layout-footer/main-layout-footer.component.ts